export const excludeClientEndpoints = {
    postInstagramExclude: '/client/instagram-exclude/',
    postWhatsappExclude: '/client/whatsapp-exclude/',
    postTelegramExclude: '/client/telegram-exclude/',
    getExcludeProfiles: '/client/exclude-profiles/',
    deleteExcludeClient: '/client/exclude-delete/',
}